module.exports = __webpack_public_path__ + "static/media/line.662d56e0.svg";